module.exports = __webpack_public_path__ + "img/kgf-logo.3a2fd44a.svg";